import styled from "styled-components";
import media from "styled-media-query";

import bgHero from "../../assets/bg-hero-desktop.png";
import bgHeroMobile from "../../assets/bg-hero-mobile.png";
import bgHeroMobileSmall from "../../assets/bg-hero-mobile-sm.png";

import { headerMobileHeight } from "../../components/header-mobile/styles";

export const SectionHero = styled.div`
  position: relative;
  padding-top: 200px;
  padding-bottom: 80px;

  ${media.between('1368px', '1699px')`
    padding-top: 150px;
    padding-bottom: 40px;
  `}

  ${media.between('1100px', '1367px')`
    padding-top: 130px;
  `}
  ${media.between('1025px', '1100px')`
    padding-top: 110px;
    padding-bottom: 30px;
  `}

  ${media.lessThan('1024px')`
    padding-top: 0;
    padding-bottom: 0;
  `}

  .container {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: space-between;

    ${media.between('1024px', '1367px')`
      max-width: 1302px;
      padding: 0 20px;
    `}

    ${media.lessThan('1024px')`
      justify-content: initial;
      flex-direction: column;
    `}
  }
  .info-desktop {
    align-self: flex-end;
    background: #144BC8;
    border: 4px solid #FFFFFF;
    box-shadow: 0px 8px 0px #FFFFFF;
    border-radius: 8px;
    width: 100%;
    max-width: 705px;
    height: 100%;
    max-height: 270px;
    margin-left: -145px;
    ${media.lessThan('1615px')`
      margin: 0 40px 0 auto;
    `}
    ${media.between('1489px','1615px')`
      margin: 0 70px 0 auto;
    `}

    ${media.lessThan('1366px')`
      max-width: 705px;
    `}

    ${media.lessThan('1200px')`
      max-width: 485px;
    `}

    ${media.lessThan('1024px')`
      max-width: 100%;
      border: none;
      box-shadow: none;
      margin: 0 auto;
    `}

    span {
      display: block;
      margin: 0 auto;
      color: #FFFFFF;
      text-align: center;
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      padding: 25px 30px 26px 20px;

      ${media.lessThan('1200px')`
        padding: 15px 10px;
        font-size: 12px;
        max-width: 450px;
      `}

      ${media.lessThan('1024px')`
        padding: 20px 24px;
        max-width: 100%;
        font-size: 18px;
        line-height: 22px;
      `}
    }

  }
  .overlay {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-color: #000031;
    background-image: url(${bgHero});

    ${media.lessThan('1024px')`
      background-position: center;
      margin-top: ${headerMobileHeight}px;
      position: static;
      height: calc(525px + ${headerMobileHeight}px);
      background-position: center center;
      background-image: url(${bgHeroMobile});
    `}

    ${media.lessThan('768px')`
      height: 460px;
    `}

    ${media.lessThan('586px')`
      margin-top: ${headerMobileHeight}px;
      height: 360px;
    `}

    ${media.lessThan('433px')`
      height: 309px;
    `}

    
    ${media.lessThan('381px')`
      background-image: url(${bgHeroMobileSmall});
      height: 209px;
    `}
  }
`;
